const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/finance.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/finance')({
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'FINANCE',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});